import { getContactsSortedByRank } from '@/services/contact-point';
import { formatHumanName } from '@medplum/core';
import { ContactPoint, Patient } from '@medplum/fhirtypes';
import { ContactPointType } from '@/components/Timeline/types';

export function getPatientName(patient: Patient): string {
  return patient?.name ? formatHumanName(patient.name[0]) : 'Unknown Patient';
}

export function getPatientPhones(patient: Patient): ContactPoint[] {
  return getContactsSortedByRank(patient?.telecom, ContactPointType.PHONE);
}
